/* eslint-disable no-useless-escape */
export const exceptionsMessages = {
  ADMIN_STUDENT_EMAIL: 'Escribe el correo electrónico',
  EMAIL_EXISTS: 'Ya existe un usuario con este correo electrónico',
  EMAIL_WRONG: 'El correo electrónico no es correcto',
}

const getEmailException = ({ code }) => {
  switch (code) {
  case 'InvalidEmailException': return 'EMAIL_WRONG'
  case 'EmailRequiredException': return 'ADMIN_STUDENT_EMAIL'
  case 'EmailAlreadyExistsException': return 'EMAIL_EXISTS'
  default: return null
  }
}

const exceptionEmailParser = ({ code }) => (
  exceptionsMessages[getEmailException({ code })]
)

export default exceptionEmailParser
